export default __webpack_public_path__ + "static/developmental_screening-9e37e1b335eda486b52506dd58aa5af6.jpeg";